import { createElementVNode as _createElementVNode, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("p", { class: "display-5 text-center" }, "Management panel", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_3 = { class: "d-flex flex-row flex-wrap" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createVNode($setup["Gauge"], {
        title: "User count",
        value: $setup.data?.allUsers.length,
        bg: "primary"
      }, null, 8, ["value"]),
      _createVNode($setup["Gauge"], {
        class: "ms-2",
        title: "Post count",
        value: $setup.data?.postCount,
        bg: "info"
      }, null, 8, ["value"])
    ])
  ], 64))
}